import { useMemo } from "react";
import { useTasksInfiniteQuery } from "../../../../entities/task";
import { useDebounce } from "../../../../shared/hooks/useDebounce";
import {
  mapFiltersFormToApi,
  AufgabenFiltersForm,
} from "./aufgabenFilters.types";
import {
  toAufgabenFiltersForm,
  useAufgabenFiltersParams,
} from "./useAufgabenFiltersParams";

const PAGE_LIMIT = 20;

export function useAufgabenFilters() {
  const [params, setParams] = useAufgabenFiltersParams();

  const filters = useMemo<AufgabenFiltersForm>(
    () => toAufgabenFiltersForm(params),
    [params],
  );

  const debouncedFilters = useDebounce(filters, 400);

  const apiFilters = useMemo(
    () => mapFiltersFormToApi(debouncedFilters, PAGE_LIMIT),
    [debouncedFilters],
  );

  const query = useTasksInfiniteQuery(apiFilters);

  return {
    filters,
    setFilters: setParams,
    ...query,
  };
}
